import React, { useContext } from 'react';
import { GaTrackingHelpers } from 'AppShell/appshell_types';

export const OwwFooterTrackingContext = React.createContext<GaTrackingHelpers>({} as GaTrackingHelpers);

export const OwwFooterTrackingProvider = <G extends GaTrackingHelpers>({
    value,
    children,
}: {
    children: React.ReactNode;
    value: G;
}) => <OwwFooterTrackingContext.Provider value={value}>{children}</OwwFooterTrackingContext.Provider>;

const useOwwFooterTracking = () => useContext(OwwFooterTrackingContext);

export default useOwwFooterTracking;

export const FOOTER_TRACKING_EVENT_CATEGORY = 'Footer';
